// extracted by mini-css-extract-plugin
export default {"column":"column__1zfXh","container":"container__XQi-0","item":"item__jWA44"};